"use client";
import React from "react";

function PopularGuide() {
  const services = [
    {
      title: "Regulatory Compliance",
      desc: "Helping businesses stay compliant with industry regulations and legal requirements.",
      icon: "⚖️",
    },
    {
      title: "Corporate Governance",
      desc: "Building strong governance structures for transparency and business growth.",
      icon: "🏛️",
    },
    {
      title: "Employment Law",
      desc: "Professional legal support for employment policies and workplace compliance.",
      icon: "👨‍⚖️",
    },
    {
      title: "ITR E-Verification",
      desc: "Fast and secure Income Tax Return verification with digital solutions.",
      icon: "📄",
    },
  ];

  return (
    <section className="legal-section">

      {/* BACKGROUND */}
      <div className="bg-circle one"></div>
      <div className="bg-circle two"></div>

      <div className="container">

        {/* HEADING */}
        <div className="section-heading text-center">

          <span className="tag">
            ✦ LEGAL SERVICES
          </span>

          <h2>
            Our Legal Compliance
            <span> Solutions</span>
          </h2>

          <p>
            Modern legal and compliance services designed
            to protect and grow your business.
          </p>

        </div>

        <div className="row align-items-center">

          {/* LEFT SIDE */}
          <div className="col-lg-5 mb-5 mb-lg-0">

            <div className="left-box">
              <h3>
                Trusted Legal Experts
                For Modern Businesses
              </h3>

              <p>
                We provide smart legal compliance solutions
                including governance, taxation, employment law,
                and regulatory consulting services.
              </p>

              <div className="features">

                <div className="feature-item">
                  ✔ Corporate Compliance
                </div>

                <div className="feature-item">
                  ✔ Tax & ITR Services
                </div>

                <div className="feature-item">
                  ✔ Employment Law Support
                </div>

              </div>

              <button className="consult-btn">
                Get Consultation →
              </button>

            </div>

          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-7">

            <div className="services-grid">

              {services.map((item, index) => (
                <div className="service-card" key={index}>

                  <div className="icon-box">
                    {item.icon}
                  </div>

                  <h4>{item.title}</h4>

                  <p>{item.desc}</p>

                  <div className="bottom-row">

                    <span>Learn More</span>

                    <div className="arrow">
                      →
                    </div>

                  </div>

                </div>
              ))}

            </div>

          </div>

        </div>

      </div>

      <style jsx>{`
        .legal-section {
          position: relative;
          padding: 100px 0;
          background: #f8fbff;
          overflow: hidden;
        }

        /* BACKGROUND */

        .bg-circle {
          position: absolute;
          border-radius: 50%;
          filter: blur(120px);
          opacity: 0.15;
        }

        .one {
          width: 300px;
          height: 300px;
          background: #06b6d4;
          top: -100px;
          left: -100px;
        }

        .two {
          width: 350px;
          height: 350px;
          background: #2563eb;
          bottom: -100px;
          right: -100px;
        }

        .container {
          position: relative;
          z-index: 2;
        }

        /* HEADING */

        .section-heading {
          margin-bottom: 70px;
        }

        .tag {
          display: inline-block;
          padding: 10px 22px;
          border-radius: 50px;
          background: rgba(16,87,132,0.08);
          color: #105784;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 1px;
          margin-bottom: 20px;
        }

        .section-heading h2 {
          font-size: 54px;
          font-weight: 800;
          color: #0f172a;
          margin-bottom: 20px;
          line-height: 1.2;
        }

        .section-heading h2 span {
          color: #105784;
        }

        .section-heading p {
          max-width: 650px;
          margin: auto;
          color: #64748b;
          line-height: 1.8;
          font-size: 16px;
        }

        /* LEFT BOX */

        .left-box {
          background: #0f172a;
          padding: 45px;
          border-radius: 30px;
          color: #fff;
          height: 100%;
          position: relative;
          overflow: hidden;
        }

        .left-box::before {
          content: "";
          position: absolute;
          width: 220px;
          height: 220px;
          background: rgba(255,255,255,0.04);
          border-radius: 50%;
          top: -80px;
          right: -80px;
        }

        .experience {
          margin-bottom: 30px;
        }

        .experience h1 {
          font-size: 75px;
          font-weight: 900;
          color: #06b6d4;
          margin-bottom: 0;
          line-height: 1;
        }

        .experience span {
          color: #cbd5e1;
          font-size: 15px;
        }

        .left-box h3 {
          font-size: 34px;
          line-height: 1.4;
          margin-bottom: 20px;
          font-weight: 700;
        }

        .left-box p {
          color: #cbd5e1;
          line-height: 1.9;
          margin-bottom: 30px;
        }

        /* FEATURES */

        .features {
          margin-bottom: 35px;
        }

        .feature-item {
          background: rgba(255,255,255,0.06);
          border: 1px solid rgba(255,255,255,0.08);
          padding: 14px 18px;
          border-radius: 14px;
          margin-bottom: 14px;
          color: #e2e8f0;
          transition: 0.3s;
        }

        .feature-item:hover {
          transform: translateX(8px);
          background: rgba(6,182,212,0.12);
        }

        /* BUTTON */

        .consult-btn {
          border: none;
          padding: 16px 30px;
          border-radius: 14px;
          background: linear-gradient(135deg, #06b6d4, #2563eb);
          color: #fff;
          font-weight: 700;
          transition: 0.4s;
          box-shadow: 0 12px 30px rgba(6,182,212,0.25);
        }

        .consult-btn:hover {
          transform: translateY(-5px);
        }

        /* SERVICES */

        .services-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 25px;
        }

        .service-card {
          background: #fff;
          padding: 35px;
          border-radius: 28px;
          transition: 0.4s;
          border: 1px solid #e2e8f0;
          position: relative;
          overflow: hidden;
          height: 100%;
        }

        .service-card::before {
          content: "";
          position: absolute;
          width: 180px;
          height: 180px;
          background: rgba(16,87,132,0.04);
          border-radius: 50%;
          top: -70px;
          right: -70px;
        }

        .service-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 50px rgba(0,0,0,0.08);
          border-color: rgba(6,182,212,0.3);
        }

        .icon-box {
          width: 70px;
          height: 70px;
          border-radius: 20px;
          background: linear-gradient(135deg, #06b6d4, #2563eb);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 30px;
          color: #fff;
          margin-bottom: 22px;
          box-shadow: 0 10px 25px rgba(6,182,212,0.25);
        }

        .service-card h4 {
          font-size: 24px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 15px;
        }

        .service-card p {
          color: #64748b;
          line-height: 1.8;
          margin-bottom: 30px;
          font-size: 15px;
        }

        .bottom-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .bottom-row span {
          color: #105784;
          font-weight: 700;
        }

        .arrow {
          width: 45px;
          height: 45px;
          border-radius: 14px;
          background: #f1f5f9;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          color: #105784;
          transition: 0.4s;
        }

        .service-card:hover .arrow {
          background: linear-gradient(135deg, #06b6d4, #2563eb);
          color: #fff;
          transform: rotate(-45deg);
        }

        /* RESPONSIVE */

        @media (max-width: 992px) {
          .services-grid {
            grid-template-columns: 1fr;
          }

          .section-heading h2 {
            font-size: 40px;
          }
        }

        @media (max-width: 768px) {
          .legal-section {
            padding: 80px 0;
          }

          .section-heading h2 {
            font-size: 30px;
          }

          .left-box {
            padding: 30px;
          }

          .left-box h3 {
            font-size: 28px;
          }

          .service-card {
            padding: 28px;
          }
        }
      `}</style>
    </section>
  );
}

export default PopularGuide;